const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function getToken() { return localStorage.getItem('admin_token'); }

async function request(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
      ...options.headers
    }
  });
  if (res.status === 401) {
    localStorage.removeItem('admin_token');
    window.location.href = '/';
    throw new Error('Session expired');
  }
  return res.json();
}

export const adminLogin      = (password)     => request('/admin/login', { method: 'POST', body: JSON.stringify({ password }) });
export const getStats        = ()             => request('/admin/stats');
export const getUsers        = (search = '')  => request('/admin/users?search=' + encodeURIComponent(search));
export const getUser         = (id)           => request('/admin/users/' + id);
export const updateUserFee   = (id, feeBps)   => request('/admin/users/' + id + '/fee', { method: 'PUT', body: JSON.stringify({ feeBps }) });
export const updateUserBoost = (id, boostBps) => request('/admin/users/' + id + '/boost', { method: 'PUT', body: JSON.stringify({ boostBps }) });
export const suspendUser     = (id, suspend)  => request('/admin/users/' + id + '/suspend', { method: 'PUT', body: JSON.stringify({ suspended: suspend }) });
export const getTransactions = (params)       => request('/admin/transactions?' + new URLSearchParams(params || {}));
export const getVault        = ()             => request('/admin/vault');
export const getSettings     = ()             => request('/admin/settings');
export const updateSetting   = (key, value)   => request('/admin/settings', { method: 'PUT', body: JSON.stringify({ key, value }) });
export const runBatch        = ()             => request('/admin/batch', { method: 'POST' });
export const runBoost        = (period)       => request('/admin/boost', { method: 'POST', body: JSON.stringify({ period }) });
export const getBoostHistory = ()             => request('/admin/boost/history');
export const getFeedback     = (params)       => request('/admin/feedback?' + new URLSearchParams(params || {}));
export const getKeywords     = ()             => request('/admin/keywords');
export const addKeyword      = (keyword, category, score) => request('/admin/keywords', { method: 'POST', body: JSON.stringify({ keyword, category, score }) });
export const deleteKeyword   = (id)           => request('/admin/keywords/' + id, { method: 'DELETE' });
export const getFlagged      = (params)       => request('/admin/flagged?' + new URLSearchParams(params || {}));
export const getReview = (params) => request('/admin/review?' + new URLSearchParams(params || {}));
export const deleteReviewItem  = (id) => request('/admin/review/'  + id, { method: 'DELETE' });
export const deleteFlaggedItem = (id) => request('/admin/flagged/' + id, { method: 'DELETE' });
export const getViolations    = (params) => request('/admin/violations?' + new URLSearchParams(params || {}));
export const deleteViolation  = (id)     => request('/admin/violations/' + id, { method: 'DELETE' });
